module.exports = __webpack_public_path__ + "static/media/sa-disabled.b7923c8b.png";